export default __webpack_public_path__ + "static/media/loader.244ab7d6.gif";